// depends 
import React, { useRef, useEffect, useState } from 'react';
import {useForm} from 'react-hook-form';
import { useNavigate } from 'react-router';
import emailjs from '@emailjs/browser';


// utils 
import caseid from '../../utils/handlers/caseid';
// import sendReceipt from '../../utils/fetchers/sendReceipt';
import newLeadNotify from '../../utils/fetchers/newLeadNotify';
import { fetchEJSkey, fetchESJserviceID } from '../../utils/fetchers/fetchEJSdata';

// css 
import '../../CSS/Pages_newSalesLead/NewLead.css';

const NewLead = () => {
    const nav = useNavigate();
    const {register, handleSubmit, setValue, formState: {errors}} = useForm({
        defaultValues: {
            name: '',
            businessName: '',
            email: '',
            phone: '',
            address: '',
            category: '',
            date: '',
            purchaseDomain: '',
            commercialCustomer: false,
            description: '',
            UUID: '',
        }
    })

    const [submitting, setSubmitting] = useState();
    var EJS = useRef({
        service: "",
        template: "template_ksd8zi8",
        key: "",
        caseType: "lead"
    })

    // ? used to track if this is a commercial customer reaching out through the website outside of the context of the data object since we are using it for some 
    // ? form control
    const [com, setCom] = useState(false);
    const updateComCustRef = () => {
        if(com === false) {
            setCom(true)
        } else {
            setCom(false)
        }
    }

    // used the check if the errors object is empty in order to show or hide the container at the bottom of the screen. 
    const isEmpty = (obj) => {
        if (Object.keys(obj).length === 0) {
            return false
        } else {
            return true
        }
    };

    // used to check the existence of a specified error, to apply element.style properties to inputs.
    const hasError = (obj, target) => {
        if (Object.keys(obj).includes(target)) {
            return true
        } else {
            return false
        }
    };

    const formSubmit = (data) => {
        setSubmitting(true)
                      // send customer receipt
        emailjs.send(EJS.current.service, EJS.current.template, data, EJS.current.key)
            .then((res) => {
                console.log("receipt sent to customer", res)
                newLeadNotify(EJS.current.service, data, EJS.current.key)
                nav('/confirmation')
            })
            .catch((err) => {
                console.log('there was an error sending the receipt', err)
                window.alert("We are experiencing issues at this time. Please try submitting your form again.")
            })
        
    }

    // get EJS info 
    useEffect(() => {
        if (EJS.current.service === "" && EJS.current.service === '') {

            async function getEJS() {
                await fetchESJserviceID()
                    .then((res) => {
                        EJS.current.service = res
                    })
                    .catch((err) => {
                        window.alert("there was an error loading this page")
                        console.log("err getting service", err)
                        setTimeout(() => {
                            window.location.reload()
                        },[5000])
                    })
                
                await fetchEJSkey()
                    .then((res) => {
                        EJS.current.key = res
                    })
                    .catch((err) => {
                        window.alert("there was an error loading this page")
                        console.log("err getting key", err)
                        setTimeout(() => {
                            window.location.reload()
                        },[5000])
                    })
            }
            getEJS()
            // create support case ID, assign it to this render of the form in the background 
            setValue('UUID', caseid(EJS.current.caseType))  
        }
    },[setValue])

    return(
        <div className='NewLead'>
            <div className='NewLead__loadingContainer' style={{display: submitting ? 'flex' : 'none'}}>
                <div class="three-quarter-spinner"></div>
            </div>
            <form id='form_NewLead' className='NewLead__form' onSubmit={handleSubmit(formSubmit)} style={{display: submitting ? 'none' : 'flex'}}>
                <h2 className='form__sectionTitle'>Contact Information</h2>
                <div className='comCust__container'>
                    <label id='label_comCust' className='NewLead__label'>If you are reaching out on behalf of a commercial business, please check the box </label>
                    <input id="check_commercialCustomer" className='NewLead__box' type="checkbox" onClick={() => {updateComCustRef()}} {...register("commercialCustomer")} />
                </div>
                <div className='form__fieldCont'>
                    <div className='fieldCont__field'>
                        <label id='label_name' className='NewLead__label'>Name* {com === true ? "(point of contact name)":""}</label>
                        <input
                            id='name'
                            name='name'
                            className='NewLead__input'
                            type='text'
                            style={{border: hasError(errors,'name') ? "2px solid #F20000" : "2px solid #1E132A"}}
                            {...register("name", { required: true, maxLength: 50 })} 
                        />
                    </div>
                    <div className='fieldCont__field' style={{display: com === true ? 'flex' : 'none'}}>
                        <label id='label_businessName' className='NewLead__label'>Name of Business*</label>
                        <input
                            id='businessName'
                            name='businessName'
                            className='NewLead__input'
                            type='text'
                            style={{border: hasError(errors,'businessName') ? "2px solid #F20000" : "2px solid #1E132A"}}
                            {...register("businessName", { required: false, maxLength: 50 })} 
                        />
                    </div>
                    <div className='fieldCont__field'>
                        <label id='label_email' className='NewLead__label'>Email*</label>
                        <input
                            id='email'
                            name='email'
                            className='NewLead__input'
                            type='email'
                            style={{border: hasError(errors,'email') ? "2px solid #F20000" : "2px solid #1E132A"}}
                            {...register("email", { required: true, maxLength: 50 })} 
                        />
                    </div>
                    <div className='fieldCont__field'>
                        <label id='label_phone' className='NewLead__label'>Phone*</label>
                        <input
                            id='phone'
                            name='phone'
                            className='NewLead__input'
                            type='tel'
                            style={{border: hasError(errors,'phone') ? "2px solid #F20000" : "2px solid #1E132A"}}
                            {...register("phone", { required: true, maxLength: 50 })} 
                        />
                    </div>
                    <div className='fieldCont__field'>
                        <label id='label_address' className='NewLead__label'>Address</label>
                        <input
                            id='address'
                            name='address'
                            className='NewLead__input'
                            type='text'
                            style={{border: hasError(errors,'address') ? "2px solid #F20000" : "2px solid #1E132A"}}
                            {...register("address", { required: true, maxLength: 50 })} 
                        />
                    </div>
                </div>

                <h2 className='form__sectionTitle'>Project Information</h2>
                <div className='form__fieldCont'>
                    <div className='fieldCont__field'>
                        <label id='label_category' className='NewLead__label'>Project Type*</label>
                        <select 
                            id='select_category' 
                            name='category'
                            className='NewLead__select'
                            style={{border: hasError(errors,'category') ? "2px solid #F20000" : "2px solid #1E132A"}}
                            {...register("category", { required: true })}>
                                <option></option>
                                <option>New Construction</option>
                                <option>Retrofitting</option>
                                <option>Remodeling</option>
                                <option>Product Purchase</option>
                        </select>
                    </div>

                    <div className='fieldCont__field' id='description'>
                        <textarea 
                            id="NewLead_description" 
                            className='NewLead__textarea' 
                            placeholder="Tell us about your project .."
                            style={{border: hasError(errors,'description') ? "2px solid #F20000" : "2px solid #1E132A"}}
                            {...register("description", {required: true})} 
                        />
                    </div>                
                </div>

                <div className='NewLead__errors' style={{display: isEmpty(errors) ? "block" : "none"}}>
                    <p className='errors__dialog'>Please resolve the following errors before submitting:</p>
                    <ul className='errors__list'>
                        {errors.name && <li className='NewLead__error'>&#8226; Please enter your name</li>}
                        {errors.businessName && <li className='NewLead__error'>&#8226; Please enter the name of your organization</li>}
                        {errors.email && <li className='NewLead__error'>&#8226; Please enter your email</li>}
                        {errors.phone && <li className='NewLead__error'>&#8226; Please enter your phone number</li>}
                        {errors.address && <li className='NewLead__error'>&#8226; Please enter your address (city and state only)</li>}
                        {errors.category && <li className='NewLead__error'>&#8226; Please select the type of project you are interested in</li>}
                        {errors.description && <li className='NewLead__error'>&#8226; Please describe your project before submitting</li>} 
                    </ul>
                </div>

                <div className='UUID_cont' style={{display: "none"}}>
                    <input
                        id='UUID'
                        name='UUID'
                        className='NewLead__input'
                        type='text'
                        readOnly
                        {...register("UUID")} 
                    />
                </div>

                <input type="submit" className='NewLead__submit' id='btn_NewLeadSubmit' lable="submit" value="Submit" style={{margin: "2% 0 2% 1%"}}/>
            </form>
        </div>
    )
}

export default NewLead;
